import $ from 'jquery';
import { gsap, TimelineMax, Power2, Power4, CSSRulePlugin, ScrollTrigger, MorphSVGPlugin } from 'gsap/all';
require("../__vendor/jquery.easing.js");
require("../__vendor/jquery.bxSlider.js");

const slider = () => {
	let sliderHeaderSpanWidth = [];
	$.each($(".slider--item"), (index, slideItem) => {
		let item = $(slideItem),
			spanWidth = item.find("h2 span").width();
		sliderHeaderSpanWidth.push(spanWidth);
	});

	// Slider Init
	$('.slider').bxSlider({
		mode: "fade",
		speed: 800,
		easing: 'cubic-bezier(.25,.46,.45,.94)',
		pager: true,
		controls: false,
		auto: true,
		pause: 5000,
		onSlideBefore: ($slideElement, oldIndex, newIndex) => {
			switch(newIndex) {
				case 0:
					document.documentElement.style.setProperty('--circle-bg-after', '#de1a24');
					break;
				case 1:
					document.documentElement.style.setProperty('--circle-bg-after', '#faa40f');
					break;
				case 2:
					document.documentElement.style.setProperty('--circle-bg-after', '#9ab2ab');
					break;
				default:
					break;
			}
			
			$(".circle").addClass("circle-change");
		},
		onSlideAfter: ($slideElement, oldIndex, newIndex) => {
			$('.active-slide').removeClass('slide--active');
    		$('.slider>div').eq(newIndex).addClass('slide--active');

			switch(newIndex) {
				case 0:
					document.documentElement.style.setProperty('--circle-bg', '#de1a24');
					break;
				case 1:
					document.documentElement.style.setProperty('--circle-bg', '#faa40f');
					break;
				case 2:
					document.documentElement.style.setProperty('--circle-bg', '#9ab2ab');
					break;
				default:
					break;
			}
			
			setTimeout(() => {
				$(".circle").removeClass("circle-change");
			}, 500);
		},
		onSliderLoad: function () {
			$('.slider>div').eq(0).addClass('slide--active');

			setTimeout(() => {
				gsap.to(".bx-wrapper .bx-pager", 0.5, {
					autoAlpha: 1
				});
			}, 3000);

			if($(window).width() > 991) {
				let circlePosition = $(".circle").position();

				$.each($(".slider--item"), (index, slideItem) => {
					let item = $(slideItem);

					item.find("h2").css("left", (circlePosition.left - sliderHeaderSpanWidth[index] - 18) + "px");
				});
			}
		}
	});
};

export default slider;